import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import io from 'socket.io-client';
import "./Test.css"
const Test = () => {
  const loc = useLocation();
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState('');
  const [user, setUser] = useState(null);
  const [userlist, setUserlist] = useState([]);
  const [msglist, setMsglist] = useState([]);
  const [socket, setSocket] = useState(null);
  const userid = loc.state.userid;
  const username = loc.state.nom;
  const  messagesContainerRef = useRef();
  useEffect(() => {
    axios.get("http://localhost:3009/users",{
      headers: {
        'api-key': process.env.REACT_APP_API_KEY
      }
     })
      .then((res) => {
        setUserlist(res.data);
        const filteredUsers = res.data.filter((user) => user.id === userid);
        setUser(filteredUsers[0]);
        toast.success("Welcome");
      });

    const newSocket = io('http://localhost:3009');
    setSocket(newSocket);
    return () => {
      newSocket.disconnect();
    };
  }, [userid]);
  useEffect(()=>{
    messagesContainerRef.current?.scrollIntoView();
  },[messages])

  const handleInputChange = (event) => {
    setInputText(event.target.value);
  };
  useEffect(() => {
    if (socket) {
      socket.on('message', (data) => {
        setMessages((prevMessages) => [...prevMessages, data]);
      });
    }
  }, [socket]);
  useEffect(() => {
    axios.get("http://localhost:3009/messages",{
      headers: {
        'api-key': process.env.REACT_APP_API_KEY
      }
     })
      .then((res) => {
        const sortedMsglist = res.data.sort((a, b) => {
          return new Date(a.createdAt) - new Date(b.createdAt);
          
        });
        
        setMsglist(sortedMsglist);
        messagesContainerRef.current?.scrollIntoView();
      })
      .catch((error) => {
        console.error('Error fetching messages:', error);
      });
  }, []);
  
  
  const handleSubmit = (event) => {
    event.preventDefault();
    if (inputText.trim() !== '' && user) {
      const messageData = {
        sender: user,
        recipientId: "6468fae46faf29e263c24d9a",
        text: inputText,
      };
      socket.emit('message', messageData);
      setInputText('');
    }
  };
  

  return (
<div className="chat-container">
  <Toaster/>
  {user && (
        
      
      <div className="messages-container" id="messagesContainer">
       
         <> 
         {msglist?.map((msg,index)=>(
          <>  
          {userlist?.map((users)=>(
        <>
        {msg.sender == users._id &&
          <div key={index}  className={`message ${msg.sender === user._id ? 'message-right' : 'message-left'}`}>
         
         <img src={users.ProfilePicture} alt="Sender Profile Picture" className="sender-profile-pic" />
            <div className="sender-info">
            {msg.sender=="6468fae46faf29e263c24d9a" 
            ? <span className="sender-name"><b>{msg.sender == user._id ? "Me" : "Admin"}</b></span>
            : <span className="sender-name"><b>{msg.sender == user._id ? "Me" : users.Name}</b></span> }  
            
            <div className="message-text">{msg.text}</div>  
            </div>
            </div>} 
          </>
            ))}
          </>

             ))}  
         </>
         {messages.map((message, index) => (
          <div key={index}  className={`message ${message.sender._id === user._id ? 'message-right' : 'message-left'}`}>
         
          <img src={message.sender.ProfilePicture} alt="Sender Profile Picture" className="sender-profile-pic" />
             <div className="sender-info">
             {message.sender._id=="6468fae46faf29e263c24d9a" 
             ? <span className="sender-name"><b>{message.sender._id == user._id ? "Me" : "Admin"}</b></span>
             : <span className="sender-name"><b>{message.sender._id == user._id ? "Me" : message.sender.Name}</b></span> }  
             
             <div className="message-text">{message.text}</div>  
             </div>
         </div> 
         

        ))}
        <div ref={messagesContainerRef}></div>
      </div>
)}
      <form id="messageForm" onSubmit={handleSubmit} className="message-form">
      <div className="input-container">
        <input
          type="text"
          id="messageInput"
          value={inputText}
          onChange={handleInputChange}
          placeholder="Type your message..."
        />
        <button type="submit" className='btn ccc btn-success'>Send</button>
        </div>
      </form>

      <ul class="background">
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
   <li></li>
</ul>
    </div>
  );
};

export default Test;


